import { render, staticRenderFns } from "./BriefsTabContentView.vue?vue&type=template&id=2cf97755&scoped=true"
import script from "./BriefsTabContentView.vue?vue&type=script&lang=js"
export * from "./BriefsTabContentView.vue?vue&type=script&lang=js"
import style0 from "./BriefsTabContentView.vue?vue&type=style&index=0&id=2cf97755&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cf97755",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_testing/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2cf97755')) {
      api.createRecord('2cf97755', component.options)
    } else {
      api.reload('2cf97755', component.options)
    }
    module.hot.accept("./BriefsTabContentView.vue?vue&type=template&id=2cf97755&scoped=true", function () {
      api.rerender('2cf97755', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/file-browser/modals/BriefsTabContentView.vue"
export default component.exports